import { useEffect, useState } from "react"

import Footer from "components/Footer";
import Header from "components/Header"
import Icon from "components/Icon"
import { loginFShare } from "services/api/fshare"
import { setAuthToken } from "services/axiosFShare"

const DATA = [
  "#vanxuanawards",
  "#giaithuongquangcaosangtao",
  "#quangcaosangtaovietnam",
  "#creativeadvertising",
  "#giaithuongquangcaosangtaovietnam",
]

const MainLayout = ({ children }) => {
  const [showArrowButton, setShowArrowButton] = useState(false)

  useEffect(() => {
    ;(async() => {
      try {
        const payload = {
          "user_email": process.env.REACT_APP_FSHARE_USER_EMAIL,
          "password": process.env.REACT_APP_FSHARE_PASSWORD,
          "app_key": process.env.REACT_APP_FSHARE_APP_KEY,
        }
        const res = await loginFShare(payload)

        if (res.data) {
          setAuthToken(res.data.token, res.data.session_id)
          localStorage.setItem('FSHARE_LOGIN_TOKEN', res.data.token)
          localStorage.setItem('FSHARE_LOGIN_SESSION_ID', res.data.session_id)
        }
      } catch (error) {}
    })()
  }, [])

  return (
    <div className="h-screen bg-background overflow-y-auto overflow-x-hidden" id="mainLayoutId"
         onScroll={(event)  =>{
           setShowArrowButton(!!event.target.scrollTop)
         }}>
      <Header />
      <div className="min-h-screen">{children}</div>
      <div className="font-secondary tags space-x-16 text-[112px] leading-[120%] mb-16 md:text-48 md:mb-12">
        {
          DATA.map(text => (
            <b key={text}>{text}</b>
          ))
        }
      </div>
      <Footer />
      {
        showArrowButton &&
        <button type={'button'} className={'flex items-center justify-center w-12 aspect-square rounded-full bg-pink fixed bottom-6 right-6 z-[98]'} onClick={() => {
          document.getElementById('mainLayoutId')?.scrollTo({ top: 0, behavior: 'smooth' })
        }}>
          <Icon name={'arrow-up'} size={32} />
        </button>
      }
    </div>
  );
};

export default MainLayout;
